import { useModalService } from "services/modal/modalService";
import { ModalBase } from "components/common/modals/modalBase/modalBase";
import { PageHeaderButton } from "components/common/pageHeaderButton/pageHeaderButton";
import "./changelogModal.scoped.scss";

export const ChangelogModal = () => {
  const { showModal } = useModalService();

  const openModal = () => {
    showModal((context) => (
      <ModalBase
        onDismiss={() => context.dismiss()} // Ensure dismiss is triggered
        dismissOnClickOutside={true} // Allow clicking outside to close
        heading="Endringslogg NORTIM / SICALC"
      >
        <div className="changelog-modal-body">
          <ul>
          <li><strong>6. mars, 2026:</strong>
            <br/>Lagt til mulighet for å gå tilbake til oppsett ved feilet beregning.
            <br/>Rettet problem med negative øst-verdier i Vest-Norge.
            <br/>Økt maksimal størrelse på opplasting for å unngå feil når beregning er ferdig.
            <br/>Beskrevet tydeligere innhold i resultat-pakke.
            <br/>Rettet feil i rapport mht. bruker-definerte bygninger.
          </li>
          <li><strong>6. mars, 2026:</strong>
            <br/>Lagt til endringslogg.
          </li>
          </ul>
        </div>
      </ModalBase>
    ));
  };

  return (
    <PageHeaderButton onClick={openModal} iconName="file-document-outline">
      Endringslogg
    </PageHeaderButton>
  );
};